import authAxios from 'src/modules/shared/axios/authAxios';

export default class CancellationQuestionnaireService {
  static async fetch(filter, orderBy, limit, offset) {
    const query = {
      filter,
      orderBy,
      limit,
      offset,
    };

    const response = await authAxios.get(
      `/user-questionnaire/cancellation`,
      { params: query },
    );

    return response.data;
  }
}
